<div style="display: flex; justify-content: flex-end">
	<mat-icon (click)="close()" style="cursor: pointer">close</mat-icon>
</div>
<br />
<div>
	<p style="font-weight: 600">{{ 'mep.components.project-data-input.information-security' | translate }}</p>
	<a
		rel="noopener"
		target="_blank"
		href="https://msggroup.sharepoint.com/sites/msg-GRO/SitePages/ISMS.aspx"
		style="color: #880e4f"
		>{{ 'mep.components.project-data-input.handbook' | translate }}
	</a>
	<p>{{ 'mep.components.project-data-input.warning' | translate }}</p>
</div>
